import { CONTENT_RELEASE, CONTENT_RELEASE_INFO } from '../content/contentVersion';
import { FESTIVAL_OFFER_2026 } from '../content/offers/festivalOffer';
import servicesCatalog from './servicesCatalog.json';

export const SERVICE_CATEGORIES = servicesCatalog.serviceCategories || [];
export const POPULAR_SERVICES = servicesCatalog.popularServices || [];
export const NEW_SERVICES = servicesCatalog.newServices || [];
export const PLATFORM_STATS = servicesCatalog.platformStats || {
  serviceRating: 0,
  totalCustomers: 0,
  verifiedPandits: 0,
  completedBookings: 0
};

// Special offers
export const OFFERS_CONTENT_VERSION = CONTENT_RELEASE;
export const OFFERS_CONTENT_AUDIT = {
  release: CONTENT_RELEASE,
  releasedOn: CONTENT_RELEASE_INFO?.releasedOn || null,
  owner: CONTENT_RELEASE_INFO?.owner || null,
  notes: CONTENT_RELEASE_INFO?.notes?.offers || []
};
export const SPECIAL_OFFERS = [FESTIVAL_OFFER_2026];
